import { Link } from 'react-router-dom'

const pillars = [
  {
    slug: 'learning',
    title: '実践的な学びの場の提供',
    description:
      '現役プロフェッショナルによる実践知の共有と次世代育成を行います。最新技術のキャッチアップやコンプライアンス、商習慣の習得をサポートします。',
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
      </svg>
    ),
  },
  {
    slug: 'network',
    title: 'ビジネス・プロフェッショナルネットワーク構築',
    description:
      '若手からベテランまで世代を超えた交流と相互支援の場を提供します。リソースネットワークの構築と信用付与により、安心して活躍できる環境を整えます。',
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    ),
  },
  {
    slug: 'business',
    title: 'ビジネス機会の創出',
    description:
      '顧客の成功と社会全体のDX/AXに貢献するプロジェクト支援を行います。協会による個人の信用保証とビジネスインフラの提供により、個人では受けられなかった案件への参画を可能にします。',
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
        <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
        <line x1="12" y1="22.08" x2="12" y2="12"></line>
      </svg>
    ),
  },
]

const Services = () => {
  return (
    <section className="services" id="services">
      <div id="topics" className="section-anchor" aria-hidden="true"></div>
      <div className="container">
        <h2 className="section-title">協会の3本柱</h2>
        <div className="service-grid">
          {pillars.map((pillar) => (
            <div key={pillar.slug} className="service-card">
              <div className="service-icon">{pillar.icon}</div>
              <h3>{pillar.title}</h3>
              <p>{pillar.description}</p>
              <Link to={`/topic/${pillar.slug}`} className="service-link">
                詳しく見る
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services

